// extracted by mini-css-extract-plugin
module.exports = {"time":"time_time_n0E588g"};